<script lang="ts">
    import cn from 'classnames';
    import { createEventDispatcher, onDestroy, onMount } from 'svelte';

    import { toastsStore } from '@components/ui/toasts/store';
    import { type Toast, ToastType } from '@components/ui/toasts/types';
    import { IconName, SvgIcon } from '@uikit/svg-icon';

    import s from './toast.module.css';

    export let type: Toast['type'];
    export let persistence: Toast['params']['persistence'] = false;
    export let classes = '';
    export let isDesktop: boolean;
    export let symbol: symbol;

    const SELF_CLOSE_MS = 3000;

    let timer: number | null = null;

    const dispatch = createEventDispatcher();
    const { removeByIndex } = toastsStore;

    const classModifierList = {
        [ToastType.Error]: s.error,
        [ToastType.Success]: s.success,
    };

    const svgList = {
        [ToastType.Error]: IconName.Alert,
        [ToastType.Success]: IconName.Check,
    };

    $: classModifier = classModifierList[type];
    $: svgIcon = svgList[type];

    const closeToast = () => dispatch('close');

    onMount(() => {
        if (!persistence) {
            timer = window.setTimeout(() => removeByIndex(symbol), SELF_CLOSE_MS);
        }
    });

    onDestroy(() => {
        if (timer) {
            window.clearTimeout(timer);
        }
    });
</script>

<div
    data-testid="{type}-toast"
    class={cn(s.root, classModifier, { [s.desktop]: isDesktop }, classes)}
>
    <div class={cn(s.iconSection)}>
        <SvgIcon icon={svgIcon} />
    </div>
    <div data-testid="message" class={cn(s.contentSection)}>
        <slot />
    </div>
    <div class={cn(s.btnSection)}>
        <button data-testid="close" class={cn(s.close)} on:click={closeToast}>
            <SvgIcon icon={IconName.Close} />
        </button>
    </div>
</div>
